const loadSlideImage = (e, slide) => {
	const $slide = $(e).find('.slider__item').eq(slide != undefined ? slide + 1 : 0),
		images = $slide.find('[data-lazyload]');

	Array.prototype.forEach.call(images, (image) => {
		loadImage(image);
	});
};

const loadSectionImage = (evt) => {
	const images = evt.find('[data-lazyload]');

	Array.prototype.forEach.call(images, (element) => {
		loadImage(element);
	});
};

const loadImage = (item) => {
	const src = item.dataset.lazyload;

	if (src == null) return;

	if (item.tagName === "IMG") {
		item.setAttribute("src", src);
	} else if (item.tagName === "SOURCE") {
		item.setAttribute("srcset", src);
	} else {
		item.style.backgroundImage = 'url("' + src + '")';
	}

	item.removeAttribute('data-lazyload');
};

const callback = (entries, observer) => {
	Array.prototype.forEach.call(entries, (entry) => {
		if (entry.intersectionRatio > 0) {
			observer.unobserve(entry.target);
			loadImage(entry.target);
		}
	});
};

document.addEventListener('DOMContentLoaded', () => {
	const images = document.querySelectorAll("[data-lazyload]");

	if (!images) return;

	if (!'IntersectionObserver' in window &&
		!'IntersectionObserverEntry' in window &&
		!'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
		Array.prototype.forEach.call(images, (element) => {
			loadImage(element);
		});
	} else {
		const config = {
			rootMargin: '300px 0px',
			threshold: 0.1
		};

		const observer = new IntersectionObserver(callback, config);

		Array.prototype.forEach.call(images, (element) => {
			observer.observe(element);
		});
	}
});

export {loadSlideImage, loadSectionImage, loadImage};

